export const LANGUAGES = {
  ENGLISH: "en",
  SPANISH: "es"
};

export const ERROR_MESSAGE = {
  SOMETHING_WENT_WRONG: "Something went wrong. Please try again.",
  REQUEST_TIMED_OUT: "Request timed out. Please try again.",
  INVALID_REQUEST: "Invalid request. Please check your input.",
  SESSION_EXPIRED: "Session expired. Please login again.",
  SERVER_ERROR: "Server error. Please try again later.",
  ELIGIBILITY_QUESTIONS_NOT_MAPPED: "Eligibility Questions are not mapped yet"
};

export const LOGO = "Square Risk Logo";
export const USER_PROFILE_IMAGE = "User Profile Image";
export const FIRST_PAGE = "first page";
export const PREVIOUS_PAGE = "previous page";
export const NEXT_PAGE = "next page";
export const LAST_PAGE = "last page";
export const NO_DATA_FOUND = "No data available";
export const SEARCH_BY = "Search By Account Name";
export const APPLICAITON_ID = "applicationId";
export const VIEW_ALL = "View All";
export const SUBMIT = "Submit";
export const DRAFT = "Draft";
export const SUBMIT_TO_QUOTE = "Submit to Quote";
export const PROCEED_TO_QUOTE = "Proceed to Quote";
export const SELECT_PAYMENT_PLAN = "SELECT_PAYMENT_PLAN";

// QUOTE SOCKET
export const QUOTE_REFRESH_APPLICAITON = "QUOTE_REFRESH-APPLICAITON";

// SIGNATURE SOCKET
export const SEND_TO_CUSTOMER = "SEND_TO_CUSTOMER";
export const SIGNED_BY_CUSTOMER = "SIGNED_BY_CUSTOMER";
export const SIGNED_BY_AGENT = "SIGNED_BY_AGENT";
export const QUOTE_APPLICATION_PDF_AVAILABLE =
  "QUOTE-APPLICATION-PDF-AVAILABLE";
export const SIGNATURE_PACKAGE_GENERATION_FAILED =
  "SIGNATURE-PACKAGE-GENERATION-FAILED";
export const POLICY_UPLOADED = "POLICY_UPLOADED";
export const PRODUCER_AGREEMENT_DOCUMENT_SIGNED =
  "PRODUCER_AGREEMENT_DOCUMENT_SIGNED";
export const PAYMENT_SUCCESS = "PAYMENT_SUCCESS";
export const FORM_CONTROL = "FORM-CONTROL";
export const FORM_FILLED_SUCCESSFULLY = "FORM_FILLED_SUCCESSFULLY";
export const APPLICATION_ARCHIVED = "APPLICATION_ARCHIVED";

// QUOTE STATUS
export const QUOTE_STATUS = {
  PROCESSING: "Processing",
  FAILED: "Failed",
  QUOTE: "Quote",
  BIND: "Bind",
  UNDER_REVIEW: "Under_review"
};
export const SCREEN_STATE = {
  SUCCESS: "success",
  PENDING_FOR_AGENT_SIGN: "pending_for_agent_sign",
  WAITNG_ON_MGA: "waiting_on_signature_package",
  PENDING_FOR_SEND_TO_CUSTOMER: "pending_for_send_to_customer",
  PAYMENT_PENDING: "payment_pending",
  REQUIRES_UNDERWRITING: "requires_underwriting_review",
  RETRY_UNDERWRITING: "retry_underwriting_submission"
};
export const APPLICATION_QUOTE_STATUS = {
  PENDING_SIGNATURE_PACKAGE_GENERATION:'pending_signture_package_generation',
  INDICATION_QUOTE:'indication_quote',
  QUOTE_PRE_BIND:'quote_pre_bind'
};

// QUOTE TYPE
export const QUOTE_TYPE = {
  AUTOMATIC_QUOTE: "AUTOMATIC_QUOTE",
  MANUAL_QUOTE: "MANUAL_QUOTE"
};
// QUOTE TYPE
export const PAYMENT_FOR = {
  AGENT: "AGENT",
  CUSTOMER: "CUSTOMER"
};

// PAYMENT SOCKET
export const PAYMENT_UPDATED = "PAYMENT-UPDATED";
export const PAYMENT_CANCELLED = "PAYMENT-CANCELLED";
export const PAYMENT_EXPIRED = "PAYMENT-EXPIRED";

// PAYMENT METHOD
export const PAYMENT_METHOD = {
  CREDIT_CARD: "CREDIT_CARD",
  PAY_LATER: "PAY_LATER",
  PAY_NOW: "PAY_NOW",
  OFFLINE: "offline",
  ACH: "ACH"
};

// SCREEN NAMES
export const SCREEN_NAME = {
  PAYMENT: "Payment",
  DOWNLOAD_POLICY: "Download Policy",
  SIGN_PROPOSAL: "Sign Proposal",
  SIGNATURE: "Signature"
};
export const APPLICAITON_TYPE = {
  AGENCY_APPLICATION: "AGENCY_APPLICATION",
  CONSUMER_APPLICATION: "CONSUMER_APPLICATION"
};

export const ZOHO_TEXT = {
  AWAITING_SIGNATURE: "Awaiting Signature",
  PRODUCER_AGREEMENT_TEXT:
    "from ZohoSign.com to sign the SquareRisk appointment agreement. You will be directed to next screen as soon as agreement is signed.",
  EMAIL_HAS_BEEN_SENT: "An email has been sent to"
};

export const CARRIERS = {
  AT_BAY: "At-Bay",
  CAT_COVERAGE: "CatCoverage",
  HISCOX: "Hiscox"
};

export const INDUSTRY_NAICS_CODES = {
  Contractors: [
    "115115",
    "238130",
    "236115",
    "236116",
    "236117",
    "236220",
    "237110",
    "237120",
    "237130",
    "237310",
    "237990",
    "238110",
    "238120",
    "238140",
    "238150",
    "238160",
    "238170",
    "238190",
    "238210",
    "238220",
    "238290",
    "238310",
    "238320",
    "238330"
  ],
  Cannabis: ["111419", "115112", "325411", "459991", "492210"],
  "Real Estate": [
    "236115",
    "236116",
    "236117",
    "531312",
    "531120",
    "531130",
    "531190",
    "531311",
    "531110",
    "561790",
    "236118",
    "236210"
  ],
  "Restaurants, Bars, & Taverns": [
    "722515",
    "722410",
    "312120",
    "722511",
    "722513",
    "722330"
  ],
  Wholesale: [
    "424820",
    "423220",
    "423210",
    "423710",
    "424810",
    "423110",
    "424410",
    "423830",
    "423450",
    "423430",
    "424510"
  ],
  Retail: [
    "445131",
    "455219",
    "457110",
    "457120",
    "449110",
    "811420",
    "444110",
    "444140",
    "441110",
    "441120",
    "812112",
    "812111",
    "812320",
    "812310"
  ],
  "Professional Services": [
    "541320",
    "541330",
    "541715",
    "541310",
    "541613",
    "523910",
    "541611",
    "541618",
    "541213",
    "921130",
    "524210",
    "524298"
  ],
  Transportation: [
    "484110",
    "484121",
    "484122",
    "484220",
    "484230",
    "454310",
    "492110",
    "485113",
    "485410",
    "485210",
    "485999",
    "485510",
    "485110",
    "485310",
    "485320"
  ]
};
export const PAYMENT_RECIEVER = {
  SR: "Agency Billing",
  CARRIER: "Direct Billing"
};

